import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        if (!hash) {
            window.scrollTo(0, 0);
            return;
        }
        // Aguarda a página renderizar antes de rolar até o elemento
        const id = hash.slice(1);
        const tryScroll = (attempts = 0) => {
            const el = document.getElementById(id);
            if (el) {
                el.scrollIntoView({ behavior: 'smooth' });
            } else if (attempts < 10) {
                setTimeout(() => tryScroll(attempts + 1), 100);
            }
        };
        setTimeout(() => tryScroll(), 50);
    }, [pathname, hash]);

    return null;
}
